import { usePathname } from 'next/navigation';

/** Locale-stripped path matching `usePath().pathWithoutQuery` (e.g. `/en/foo` → `/foo`). */
export const getPathWithoutLocale = (pathname: string): string => {
  const pathWithoutQuery = (pathname.split('?')[0] || '/').trim();
  const parts = pathWithoutQuery.split('/').filter(Boolean);
  const maybeLocale = parts[0];
  const rest = maybeLocale && /^[a-z]{2}(-[A-Z]{2})?$/.test(maybeLocale) ? parts.slice(1) : parts;
  return `/${rest.join('/')}`;
};

const usePath = () => {
  const absolutePath = usePathname();

  const path = absolutePath.split('/').slice(2).join('/') ?? '/';

  const pathWithoutQuery = getPathWithoutLocale(absolutePath);

  return { path: `/${path}`, absolutePath, pathWithoutQuery };
};
export default usePath;
